export default {
    editions: [],
    domains: []
};
